import { CarouselButtonNext, LinkCtaNext } from '~/components-v2'
import { connectorsData } from '../data/connectors'
import { useState } from 'react'

export const Connectors = () => {
  const [activeConnector, setActiveConnector] = useState(0)
  const connectorCount = connectorsData.length

  const showPreviousConnector = () => {
    setActiveConnector((prev) => (prev - 1 + connectorCount) % connectorCount)
  }

  const showNextConnector = () => {
    setActiveConnector((prev) => (prev + 1) % connectorCount)
  }

  return (
    <section className="page-section section-spacing connectors-section">
      <fieldset
        className="page-section__inner connectors-wrapper"
        aria-label="Select a connector"
      >
        <div className="connector-content">
          <hgroup className="">
            <div className="text-combo">
              <h2 className="heading-xl text-brand-dark">
                Access your semantic layer from any AI platform
              </h2>
              <p className="body-l">
                Query data via Omni's MCP server, APIs, and integrations.
              </p>
            </div>
          </hgroup>

          {/* Tab buttons */}
          <div className="connector-tabs">
            {connectorsData.map((connector, index) => (
              <button
                aria-pressed={index === activeConnector}
                className={index === activeConnector ? 'is-active' : undefined}
                key={connector.id}
                onClick={() => setActiveConnector(index)}
                type="button"
              >
                {connector.logoSrc ? (
                  <img src={connector.logoSrc} alt={connector.name} />
                ) : (
                  <span>{connector.name}</span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div className="connector-preview">
          {/* Screenshots — stacked, one shown at a time */}
          <div className="connector-screenshots">
            {connectorsData.map((connector, index) => (
              <div
                key={connector.id}
                className={`connector-screenshot ${
                  index === activeConnector ? 'is-active' : ''
                }`}
              >
                <img
                  loading="lazy"
                  src={connector.screenshot}
                  alt={`${connector.name} interface`}
                />
              </div>
            ))}
          </div>

          <div className="connector-footer">
            {/* Link — one per connector, visible only when its tab is active */}
            <div className="connector-links">
              {connectorsData.map((connector, index) => (
                <LinkCtaNext
                  className={`connector-link ${index === activeConnector ? 'is-active' : ''}`}
                  external={true}
                  href={connector.linkHref}
                  key={connector.id}
                >
                  {connector.linkText}
                </LinkCtaNext>
              ))}
            </div>

            <div className="carousel-controls-next">
              <CarouselButtonNext
                aria-label="Show previous connector"
                direction="previous"
                onClick={showPreviousConnector}
              />
              <CarouselButtonNext
                aria-label="Show next connector"
                direction="next"
                onClick={showNextConnector}
              />
            </div>
          </div>
        </div>
      </fieldset>
    </section>
  )
}
